import type { LeadTimeCalculatorInput } from '@calculations/lead-time/input';

import {
  PlanningLeadTime,
  PlanningLeadTimeLeadTimeStrategy,
  PlanningLeadTimeLeadTimeStrategyResult,
} from './types';

/**
 * The planning lead time is Visual's `PART_SITE.planning_leadtime` for the
 * quoted part, which is a day count.
 *
 * It converts at the *planning* week rather than the production week. This is
 * the same column the quantity-aware strategy reads for its material lead time,
 * a row apart, and the same reasoning applies: a planner records how long the
 * part takes to arrive in the seven day weeks the ERP counts, not in the days
 * the plant happens to run.
 *
 * The conversion is written out rather than taken from `daysToWeeksCeil`, which
 * lives in `lib`: `lib` depends on this package, so the import cannot run the
 * other way.
 */
export function runPlanningLeadTimeStrategy(
  strategy: PlanningLeadTimeLeadTimeStrategy,
  input: LeadTimeCalculatorInput,
): PlanningLeadTimeLeadTimeStrategyResult {
  const { planningLeadTime } = input;
  const { planningDaysPerWeek } = strategy.config;

  if (planningLeadTime && planningLeadTime > 0) {
    return {
      name: PlanningLeadTime,
      weeks: Math.ceil(planningLeadTime / planningDaysPerWeek),
    };
  }

  return {
    name: PlanningLeadTime,
    weeks: null,
  };
}
